import { ReactComponent as Operable } from 'src/assets/svg/Operable.svg';
import { ReactComponent as Understandable } from 'src/assets/svg/Understandable.svg';
import { ReactComponent as Robust } from 'src/assets/svg/Robust.svg';
import Eye from '@geist-ui/icons/eye';

export const issuesPour = [
  {
    title: 'issuesByPOUR.Perceivable',
    field: 'Perceivable',
    filter: 'issueType',
    icon: <Eye role="presentation" size={32} color="#264547" />,
  },
  {
    title: 'issuesByPOUR.Operable',
    field: 'Operable',
    filter: 'issueType',
    icon: <Operable role="presentation" />,
  },
  {
    title: 'issuesByPOUR.Understandable',
    field: 'Understandable',
    filter: 'issueType',
    icon: <Understandable role="presentation" />,
  },
  {
    title: 'issuesByPOUR.Robust',
    field: 'Robust',
    filter: 'issueType',
    icon: <Robust role="presentation" />,
  },
];
